import React, { type FC } from 'react';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import Image from 'src/components/Image';
import RichTextRenderer from 'src/components/RichTextRenderer/RichTextRenderer';
import { mergeQueryParams } from 'src/lib/image-helpers';
import type { AuthorBio } from './Author.types';
import styles from './Author.module.scss';

const Author: FC<AuthorBio> = ({ entryId, name, image, title, blurb }) => {
  const inspectorProps = useContentfulInspectorMode({ entryId });
  const hasBlurb = !!blurb?.content?.length;
  const isNameOnly = !title && !hasBlurb;

  return (
    <div
      className={
        isNameOnly ? `${styles.author} ${styles.authorNameOnly}` : styles.author
      }
      {...(entryId ? inspectorProps({ fieldId: 'name' }) : null)}
    >
      {image?.src && (
        <div className={styles.authorPhoto}>
          <Image
            src={mergeQueryParams(image.src, {
              w: '120',
              h: '120',
              fit: 'fill',
              f: 'center',
              r: '100',
            })}
            alt={image.alt}
            isLazy={false}
            width={60}
            height={60}
          />
        </div>
      )}
      <div className={styles.authorInfo}>
        <div className={styles.name}>{name}</div>
        {title && <div className={styles.title}>{title}</div>}
        {hasBlurb && (
          <div className={styles.blurb}>
            <RichTextRenderer content={blurb} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Author;
